import type { PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { EditClientContractTermFormValues } from '../schema';

type IGenerateRequestBody = (
  formValues: EditClientContractTermFormValues
) => PutApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsIdBody;

/**
 * フォームのフィールド値を PUT API リクエストボディに変換する
 *
 * - UI 側で disabled にしているフィールドは値が変わらないため、フォーム値をそのまま送信する
 * - endedOn が設定されている場合は 'yyyy-MM-dd' 形式で送信
 * - endedOn が未設定の場合は ended_on を null として送信（無期限）
 */
export const generateRequestBody: IGenerateRequestBody = ({
  contractPlanId,
  startedOn,
  endedOn,
}) => ({
  client_contract: {
    contract_plan_id: Number(contractPlanId),
    started_on: formatDate({ date: startedOn, formatType: 'yyyy-MM-dd' }),
    ended_on: endedOn ? formatDate({ date: endedOn, formatType: 'yyyy-MM-dd' }) : null,
  },
});
